interface experienceI {
	title: string
	content: {
		workingAsA: string
		workDuration: string
		website?: string
		learned: string[]
	}
}

export const experience: experienceI[] = [
	{
		title: "Evert",
		content: {
			workingAsA: "Backend Engineering Lead",
			workDuration: "Feb 2024 – Present",
			website: "https://evert.no/",
			learned: [
				"Lead team in designing and delivering scalable, secure, high-performance web applications using GO, Nest.js, TypeScript, MongoDB, PostgreSQL, and AWS.",
				"Architected and built the backend system from scratch, establishing the foundation for a scalable and secure platform in close collaboration with the team.",
				"Integrated Kafka for notifications and messaging between microservices, improving event-driven communication and reliability.",
				"Collaborate with stakeholders to understand their needs and turn them into effective technical solutions.",
				"Conducted a proof-of-concept (PoC) for AI integration using Hugging Face and LangChain.",
			],
		},
	},
	{
		title: "Tech Ciao",
		content: {
			workingAsA: "Senior Software Engineer",
			workDuration: "Oct 2022 – Aug 2024",
			website: "https://techciao.com/",
			learned: [
				"Architecting backend services that meet the most demanding requirements using Nestjs, typeORM, Redis, and PostgresSQL.",
				"Implemented Microservices using Nestjs, communicating through Kafka.",
				"Building CI/CD pipelines on Heroku, render for web applications and services, ensuring fast and reliable deployments.",
				"Leveraging my expertise, I have successfully implemented efficient and reliable strategies for uploading large files to AWS S3 in chunks, ensuring optimal performance.",
				"Designing efficient and scalable database schemas for NoSQL databases such as DynamoDB, ensuring reliable and high-performance data management.",
			],
		},
	},
	{
		title: "Sofit",
		content: {
			workingAsA: "Web Software Engineer",
			workDuration: "Oct 2021 – Jan 2023",
			website: "https://sofit.ltd/",
			learned: [
				"Leading a team to implement Micro-Frontend Architecture using React, Module Federation, Webpack, Ant Design, and other 3rd-party libraries.",
				"Building efficient and scalable web systems focusing on performance and maintainability.",
				"Developing RESTful web services using Node.js.",
				"Containerizing applications with Docker and assisting the team with deployments.",
				"Collaborating with cross-functional teams on projects requiring frontend and backend expertise.",
			],
		},
	},
	{
		title: "Vappar",
		content: {
			workingAsA: "Software Engineer",
			workDuration: "Sep 2020 – Oct 2021",
			website: "https://vappar.com/",
			learned: [
				"Writing modern and performant code to build web applications using React.js and other 3rd party libraries.",
				"Integrating GraphQL and REST APIs on the frontend.",
				"Collaborating and communicating daily with design and backend teams to ensure seamless integration.",
				"Working with a variety of libraries including React.js, Material UI, and Styled Components.",
			],
		},
	},
	{
		title: "Blue Raven",
		content: {
			workingAsA: "Full Stack Engineer",
			workDuration: "Mar 2019 – Aug 2020",
			website: "http://blueraveninc.com/",
			learned: [
				"Learned better designing of APIs using Node.js.",
				"Collaborated with engineering and design teams to integrate external APIs into web pages and applications.",
				"Evaluated and improved existing systems under mentor supervision.",
			],
		},
	},
	{
		title: "Gulzar Soft",
		content: {
			workingAsA: "JavaScript Developer",
			workDuration: "Oct 2018 – Feb 2019",
			learned: [
				"Developing web applications by writing efficient code using vanilla JavaScript and frameworks like React.js.",
				"Utilizing third-party libraries to enhance frontend functionality.",
				"Integrating REST APIs on the frontend for dynamic data handling.",
				"Collaborating daily with design and backend teams to improve web applications.",
			],
		},
	},
]
